// extracted by css-extract-rspack-plugin
module.exports =  {"root":"OCRScopeJobDetailBodyTitle__root___Rzukp"};